import {
    EVENT_CREATE,
    EVENT_LIST,
    EVENT_TODAY_LIST,
    EVENT_ID,
    EVENT_UPDATE,
    EVENT_UPDATE_STATUS,
    EVENT_DELETE,
    AGENDA_CREATE,
    AGENDA_LIST,
    AGENDA_ID,
    AGENDA_UPDATE,
    AGENDA_DELETE,
    NOTULENSI_CREATE,
    NOTULENSI_LIST,
    NOTULENSI_ID,
    NOTULENSI_UPDATE,
    NOTULENSI_DELETE,
    PRESENSI_LIST,
    PRESENSI_ID,
    PRESENSI_UPDATE,
    PRESENSI_DELETE,
    ATTACHMENT_CREATE,
    ATTACHMENT_DELETE,
    ATTACHMENT_DELETE_ALL,
    TASK_CREATE,
    TASK_LIST,
    TASK_ID,
    TASK_UPDATE,
    TASK_DELETE,
    APPROVER_LIST,
    EVENT_LIST_PROGRESS,
    NOTULENSI_APPROVE,
    NOTULENSI_READY_TO_APPROVE,
    COMMENT_ADD_EM,
    AGENDA_UPDATE_STATE,
    AGENDA_NOTIFICATION,
    EVENT_NOTIFICATION,
    EVENT_CHOISE_CALENDAR,
    PAGE_EVENT_LIST,
    NOTULENSI_ID_SETNULL,
    SPESIMEN_ID,
} from 'shared/constants/ActionTypes';

const eventList = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const eventTodayList = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const agendaList = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const eventListProgress = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const approverList = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const taskList = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const eventChoiseCalendar = {
    message: null,
    result: [],
    success: false
}

const initialState = {
    eventCreate: null,
    eventList: eventList,
    eventTodayList: eventTodayList,
    eventId: null,
    eventUpdate: null,
    eventUpdateStatus: null,
    eventDelete: null,
    agendaCreate: null,
    agendaList: agendaList,
    agendaId: null,
    agendaUpdate: null,
    agendaDelete: null,
    notulensiCreate: null,
    notulensiList: null,
    notulensiId: null,
    notulensiUpdate: null,
    notulensiDelete: null,
    presensiList: null,
    presensiId: null,
    presensiUpdate: null,
    presensiDelete: null,
    attachmentCreate: [],
    taskCreate: null,
    taskList: taskList,
    taskId: null,
    taskUpdate: null,
    taskDelete: null,
    approverList: approverList,
    eventListProgress: eventListProgress,
    notulensiApprove: null,
    notulensiReadyToApprove: null,
    commentAddEm: null,
    agendaUpdateState: null,
    agendaNotification: null,
    eventNotification: null,
    eventChoiseCalendar: eventChoiseCalendar,
    pageEventList:null,
    spesimenId: null
}

const EventManagementReducer = (state=initialState,action) => {
    switch (action.type) {
        case EVENT_CREATE:
            return {
                ...state,
                eventCreate: action.payload
            }
        case EVENT_LIST:
            return {
                ...state,
                eventList: action.payload
            }
        case EVENT_TODAY_LIST:
            return {
                ...state,
                eventTodayList: action.payload
            }
        case EVENT_ID:
            return {
                ...state,
                eventId: action.payload
            }
        case EVENT_UPDATE:
            return {
                ...state,
                eventUpdate: action.payload
            }
        case EVENT_UPDATE_STATUS:
            return {
                ...state,
                eventUpdateStatus: action.payload
            }
        case EVENT_DELETE:
            return {
                ...state,
                eventDelete: action.payload
            }
        case AGENDA_CREATE:
            return {
                ...state,
                agendaCreate: action.payload
            }
        case AGENDA_LIST:
            return {
                ...state,
                agendaList: action.payload
            }
        case AGENDA_ID:
            return {
                ...state,
                agendaId: action.payload
            }
        case AGENDA_UPDATE:
            return {
                ...state,
                agendaUpdate: action.payload
            }
        case AGENDA_DELETE:
            return {
                ...state,
                agendaDelete: action.payload
            }
        case NOTULENSI_CREATE:
            return {
                ...state,
                notulensiCreate: action.payload
            }
        case NOTULENSI_LIST:
            return {
                ...state,
                notulensiList: action.payload
            }
        case NOTULENSI_ID:
            return {
                ...state,
                notulensiId: action.payload
            }
        case NOTULENSI_UPDATE:
            return {
                ...state,
                notulensiUpdate: action.payload
            }
        case NOTULENSI_DELETE:
            return {
                ...state,
                notulensiDelete: action.payload
            }
        case PRESENSI_LIST:
            return {
                ...state,
                presensiList: action.payload
            }
        case PRESENSI_ID:
            return {
                ...state,
                presensiId: action.payload
            }
        case PRESENSI_UPDATE:
            return {
                ...state,
                presensiUpdate: action.payload
            }
        case PRESENSI_DELETE:
            return {
                ...state,
                presensiDelete: action.payload
            }
        case TASK_CREATE:
            return {
                ...state,
                taskCreate: action.payload
            }
        case TASK_LIST:
            return {
                ...state,
                taskList: action.payload
            }
        case TASK_ID:
            return {
                ...state,
                taskId: action.payload
            }
        case TASK_UPDATE:
            return {
                ...state,
                taskUpdate: action.payload
            }
        case TASK_DELETE:
            return {
                ...state,
                taskDelete: action.payload
            }
        case APPROVER_LIST:
            return {
                ...state,
                approverList: action.payload
            }
        case ATTACHMENT_CREATE:
            return {
                ...state,
                attachmentCreate: [...state.attachmentCreate, action.payload]
            }
        case ATTACHMENT_DELETE:
            return {
                ...state,
                attachmentCreate: action.payload.length === 0 ? [] : action.payload
            }
        case ATTACHMENT_DELETE_ALL:
            return {
                ...state,
                attachmentCreate: []
            }
        case EVENT_LIST_PROGRESS:
            return {
                ...state,
                eventListProgress: action.payload
            }
        case NOTULENSI_APPROVE:
            return {
                ...state,
                notulensiApprove: action.payload
            }
        case NOTULENSI_READY_TO_APPROVE:
            return {
                ...state,
                notulensiReadyToApprove: action.payload
            }
        case COMMENT_ADD_EM:
            return {
                ...state,
                commentAddEm: action.payload
            }
        case AGENDA_UPDATE_STATE:
            return {
                ...state,
                agendaUpdateState: action.payload
            }
        case AGENDA_NOTIFICATION:
            return {
                ...state,
                agendaNotification: action.payload
            }
        case EVENT_NOTIFICATION:
            return {
                ...state,
                eventNotification: action.payload
            }
        case EVENT_CHOISE_CALENDAR:
            return {
                ...state,
                eventChoiseCalendar: action.payload
            }
        case PAGE_EVENT_LIST:
            return {
                ...state,
                pageEventList: action.payload
            }
        case NOTULENSI_ID_SETNULL:
            return {
                ...state,
                notulensiId: null
            }
        case SPESIMEN_ID:
            return {
                ...state,
                spesimenId: action.payload
            }
        default:
            return {
                ...state
            }
        }
    };

export default EventManagementReducer
